import { config } from '@guest-widgets/shared/src/config';
import { useQueryRouter } from '@guest-widgets/shared/src/components/Router/QueryRouter';

export const useQueryStringSettings = () => {
  const { productIdQueryKey } = config;
  const searchParams = useQueryRouter();
  const productId = searchParams.get(productIdQueryKey);
  return { productId: productId || undefined };
};
